<template>
	<ion-button
		v-if="shareIsSupported"
		size="small"
		fill="outline"
		color="success"
		@click="handleShare"
	>
		<ion-icon slot="start" :icon="shareOutline" />
		{{ $t("common.share") }}
	</ion-button>
</template>

<script setup lang="ts">
	import { IonButton, IonIcon } from "@ionic/vue";
	import { shareOutline } from "ionicons/icons";
	import { useShare } from "@vueuse/core";
	import type { InviteDTO } from "seedgreen-shared/dtos/InviteDTO";
	import { sendToast } from "@/utils/sendToast";
	import { useI18n } from "vue-i18n";

	interface Props {
		invite: Pick<InviteDTO, "userName" | "signupLink">;
	}

	const props = defineProps<Props>();
	const { t } = useI18n();
	const { share, isSupported: shareIsSupported } = useShare();

	/**
	 * Share the invite link using the Web Share API
	 */
	const handleShare = async () => {
		try {
			await share({
				title: "SeedGreen Invite",
				text: `You've been invited to join SeedGreen as ${props.invite.userName}`,
				url: props.invite.signupLink,
			});
		} catch (error) {
			// User canceling the share dialog is normal behavior, don't show error
			if (error instanceof Error && error.name === "AbortError") {
				return;
			}

			console.error("Failed to share link:", error);
			await sendToast(t("invite-modal.failed-to-share"), 2000, "danger");
		}
	};
</script>
